/* eslint-disable @typescript-eslint/no-shadow */
import { ToastContainer } from 'react-toastify'
import { DivInput, InputStyle, Span } from '../Users/Users.style'
import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'
import {
  Container,
  SpanIcon,
  FilterStatus,
  SpanFilter,
  Ul,
  Td,
} from '../../layouts/LayoutTable/LayoutTable'
import { FilterIcon } from '../../assets/icons/filter'
import { ItemFilter } from '../../components/ItemFilter/ItemFilter'
import { GenericTable } from '../../components/GenericTable/GenericTable'

import { Button } from '../../components/SideBar/Menu.style'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import { Pagination } from '../../components/Pagination/Pagination'
import { Loading } from '../../components/Loading/Loading'
import { useSalesPeople } from './useSalesPeople'

export function SalesPeople() {
  const {
    searchValue,
    setSearchValue,
    isShowFilter,
    currentPage,
    setCurrentPage,
    salesPeople,
    fetchSalesPeople,
    isLoading,
    handleKeyDown,
    goToPage,
    showFilter,

    statusChecked,
    statusCheckedTodos,
    setStatusCheckedFiltro,
    handleCheckboxChange,
  } = useSalesPeople()

  return (
    <div>
      <ToastContainer theme="dark" />
      <DivTitle color="black" size={22}>
        Vendedores
      </DivTitle>
      <Container>
        <DivInput>
          <InputStyle
            value={searchValue}
            onChange={event => setSearchValue(event.target.value)}
            onKeyDown={handleKeyDown}
            border={colors.grey300}
            placeholder="Pesquise uma palavra-chave"
            sizeX="264px"
            sizeY="42px"
          />
          <Span onClick={fetchSalesPeople}>
            <SearchIcon />
          </Span>
          <SpanIcon onClick={showFilter}>
            <FilterIcon />
          </SpanIcon>
          <div>
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <>
                <GenericTable
                  size="270px"
                  headers={['Vendedor', 'Status']}
                  spacing="60px"
                  font="16px"
                >
                  {salesPeople.content &&
                    salesPeople.content.map(vendedor => (
                      <tr
                        onClick={() => goToPage(vendedor.id)}
                        className="itemTable"
                        key={vendedor.id}
                      >
                        {/* <td>{vendedor.id}</td> */}
                        <td className="col2">{vendedor.nome}</td>
                        <td className="col2">
                          <Td classification={vendedor.classificacao}>
                            {vendedor.classificacao
                              .replace('_', ' ')
                              .toLowerCase()}
                          </Td>
                        </td>
                      </tr>
                    ))}
                </GenericTable>
                <Pagination
                  pageNumber={currentPage}
                  pageSize={salesPeople.totalElements}
                  offSet={salesPeople.size}
                  onClick={page => setCurrentPage(page)}
                />
              </>
            )}
          </div>
        </DivInput>

        {isShowFilter && (
          <FilterStatus>
            <SpanFilter>Filtrar por: </SpanFilter>

            <div>
              <Ul>
                <ItemFilter
                  top="2px"
                  checked={!statusCheckedTodos.includes('TODOS')}
                  onChange={() => {
                    // handleFiltroStatus(['Todos'])
                    handleCheckboxChange('TODOS')
                  }}
                  text="Todos"
                  id="all"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('EM_ALTA')}
                  onChange={() => {
                    // handleFiltroStatus(['Em alta'])
                    handleCheckboxChange('EM_ALTA')
                  }}
                  text="Em alta"
                  id="onHigh"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('EM_BAIXA')}
                  onChange={() => {
                    // handleFiltroStatus(['Em baixa'])
                    handleCheckboxChange('EM_BAIXA')
                  }}
                  text="Em baixa"
                  id="low"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('NEUTRO')}
                  onChange={() => {
                    // handleFiltroStatus(['Neutro'])
                    handleCheckboxChange('NEUTRO')
                  }}
                  text="Neutro"
                  id="neutro"
                />
              </Ul>
            </div>
            <Button
              buttonType="SMALL"
              type="button"
              onClick={() => {
                setStatusCheckedFiltro(statusChecked)
                showFilter()
              }}
            >
              Aplicar
            </Button>
          </FilterStatus>
        )}

        {/* {isShowFilter ? (
          <FilterStatus>
            <SpanFilter>Filtrar por:</SpanFilter>
            <div>
              <Ul>
                <ItemFilter
                  top="2px"
                  checked={check === 0}
                  onChange={() => setCheck(0)}
                  text="Todos"
                  id="all"
                />
                <ItemFilter
                  top="2px"
                  checked={check === 1}
                  onChange={() => setCheck(1)}
                  text="Em alta"
                  id="onHigh"
                />
                <ItemFilter
                  top="2px"
                  checked={check === 2}
                  onChange={() => setCheck(2)}
                  text="Em baixa"
                  id="low"
                />
                <ItemFilter
                  top="2px"
                  checked={check === 3}
                  onChange={() => setCheck(3)}
                  text="Neutro"
                  id="neutro"
                />
              </Ul>
            </div>
            <Button
              buttonType="SMALL"
              type="button"
              onClick={() => {
                fetchSalesPeople()
                showFilter()
              }}
            >
              Aplicar
            </Button>
          </FilterStatus>
        ) : null} */}
      </Container>
    </div>
  )
}
